import api from "./core";

const basePath = "api/kiosk/Auth";

export default {
  authenticate(credentials) {
    return api.post(`${basePath}/Login`, credentials);
  },
  token(token) {
    return api.token(token);
  },
  getCurrentUser() {
    return api.get(`${basePath}/CurrentUser`);
  },
  getCaptchaImg() {
    return api.get(`${basePath}/Captcha`);
  },
  getLoginAttempts() {
    return api.get(`${basePath}/Attempts`);
  }
};
